import { useQuery } from '@tanstack/react-query';

import { Importer } from '@e-origin/shared';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

export const useImporter = (id: string) =>
  useQuery({
    queryKey: ['importer', id],
    queryFn: async (): Promise<Importer> => {
      try {
        const data = await request({
          path: `importer/retrieve-importer-details/${id}`,
          method: 'GET',
          authenticate: true,
        });
        return data.importer;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch importer details');
      }
    },
    enabled: !!id,
  });
